import { useMutation } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

import { GET_JOB_COMMENTS_QUERY as getJobCommentsQuery } from './useGetJobComments';

const mutation = gql`
  mutation JobAddComment(
    $jobId: String!
    $cloudId: String!
    $comment: String!
  ) {
    jobAddComment(
      input: { jobId: $jobId, cloudId: $cloudId, comment: $comment }
    ) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/JobAddComment').type;

export type JobAddCommentVariables = OperationVariables<typeof mutation>;
export type JobAddCommentResult = OperationData<typeof mutation>;

export const useJobAddComment = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) => {
      return _mutate({
        context: { service: 'core' },
        refetchQueries: [
          {
            query: getJobCommentsQuery,
            variables: { cloudId: options?.variables?.jobId },
          } as never,
        ],
        awaitRefetchQueries: true,
        ...options,
      });
    },
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
